import { useContext, useEffect, useState } from "react";
import MapContext from "../Map/MapContext";
import OLVectorLayer from "ol/layer/Vector";

const VectorLayer = ({ source, style, zIndex ,type }) => {
	const { map } = useContext(MapContext);
	const [couche, setCouche] = useState(null);

	useEffect(() => {
		if (!map) return;
		async function anyNameFunction() {

			let vectorLayer = new OLVectorLayer({
				renderers: ['Canvas', 'VML'],
				source: await source(),
				style,
				type
			});

			setCouche(vectorLayer)
			map.addLayer(vectorLayer);
			vectorLayer.setZIndex(zIndex);
		}    // Execute the created function directly
		anyNameFunction();

		return () => {
			if (map) {
				map.removeLayer(couche);
			}
		};
		// eslint-disable-next-line
	}, [map]);

	return null;
};

VectorLayer.defaultProps={
	type:"",
	zIndex:0,
}

export default VectorLayer;